import React, { useEffect, useRef, useState } from "react";

const DigitalLeadInfo = (props) => {
  const infoForm = useRef(null);
  const [leadsInfoData, setLeadsInfoData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [searchdata, setSearchdata] = useState({});

  const leadsInfoCardData = [
    {
      id: "totalleads",
      title: "Total Leads",
      count: leadsInfoData?.totalLeads || 0,
      icon: imagepaths.AdminLeadsIconActive,
    },
    {
      id: "digitalleads",
      title: "Digital Leads",
      count: leadsInfoData?.digitalLeads || 0,
      icon: imagepaths.userWarningIcon,
    },
    {
      id: "offlineleads",
      title: "Offline Leads",
      count: leadsInfoData?.offlineLeads || 0,
      icon: imagepaths.userCheckmarkIcon,
    },
    {
      id: "enquiresleads",
      title: "Enquires Leads",
      count: leadsInfoData?.enquiryLeads || 0,
      icon: imagepaths.userRightIcon,
    },
  ];

  // ADMIN LEADS INFO
  const getLeadsType = (query, params) => {
    let data = {
      ...(params && params === "CUSTOM"
        ? {
            ...query,
            timeline: "CUSTOM",
          }
        : {
            ...query,
            timeline: timeline,
          }),
    };

    console.log({ params, data, timeline });

    props.apis.apiGetDashboardLeadsType(data).then((res) => {
      setLeadsInfoData(res);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "leadinfo-column-startDate",
      "leadinfo-column-endDate",
      "leadinfo-column-search_btn",
      "leadinfo-column-reset_btn",
    ];
    // console.log({ val });
    props.onLeadInfoTimelineChange(val);
    if (val === "CUSTOM") {
      showInputs(inputs);
      setLeadsInfoData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    props.onLeadInfoCustomTimelineChange(queryData);
    setSearchdata(queryData);
    getLeadsType(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "leadinfo-column-startDate",
      "leadinfo-column-endDate",
      "leadinfo-column-search_btn",
      "leadinfo-column-reset_btn",
    ];
    props.onLeadInfoCustomTimelineChange({});
    hideInputs(inputs);
    getLeadsType({}, "TODAY");
  };

  useEffect(() => {
    // ADMIN LEADS INFO
    getLeadsType();
  }, [timeline]);

  props.$setNode({
    props,
    leadsInfoData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadinfo-column-startDate"
            >
              <AppInputFocus
                type="date"
                name="startDate"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadinfo-column-endDate"
            >
              <AppInputFocus
                type="date"
                name="endDate"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadinfo-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadinfo-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Search</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0 pt-md-4">
          {leadsInfoCardData &&
            leadsInfoCardData.map((data) => {
              return (
                <>
                  <div className="col-xl-3 col-sm-6">
                    <div className="card dashboard_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon">
                          <img src={data?.icon} alt={data?.title} />
                        </div>
                        <div className="content">
                          <p className="count">{data?.count}</p>
                          <p className="card_label">{data?.title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(DigitalLeadInfo);
